// Component barrel exports

// Avatar
export {
  Avatar,
  AvatarImage,
  AvatarFallback,
  avatarVariants,
} from './primitives/avatar';
export type {
  AvatarProps,
  AvatarImageProps,
  AvatarFallbackProps,
} from './primitives/avatar';

// Badge
export { Badge, badgeVariants } from './primitives/badge';
export type { BadgeProps } from './primitives/badge';

// Button
export { Button, buttonVariants } from './primitives/button';
export type { ButtonProps } from './primitives/button';

// Checkbox
export { Checkbox, checkboxVariants } from './primitives/checkbox';
export type { CheckboxProps } from './primitives/checkbox';

// Card
export {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from './primitives/card';

// Dialog
export {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from './primitives/dialog';
export type {
  DialogProps,
  DialogTriggerProps,
  DialogContentProps,
} from './primitives/dialog';

// DropdownMenu
export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuCheckboxItem,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuGroup,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
} from './primitives/dropdown-menu';
export type {
  DropdownMenuProps,
  DropdownMenuTriggerProps,
  DropdownMenuContentProps,
  DropdownMenuItemProps,
  DropdownMenuCheckboxItemProps,
  DropdownMenuRadioGroupProps,
  DropdownMenuRadioItemProps,
  DropdownMenuSubProps,
  DropdownMenuSubTriggerProps,
  DropdownMenuSubContentProps,
} from './primitives/dropdown-menu';

// Popover
export {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverClose,
} from './primitives/popover';
export type {
  PopoverProps,
  PopoverTriggerProps,
  PopoverContentProps,
  PopoverCloseProps,
} from './primitives/popover';

// Input
export { Input, inputVariants } from './primitives/input';
export type { InputProps } from './primitives/input';

// Label
export { Label, labelVariants } from './primitives/label';
export type { LabelProps } from './primitives/label';

// Radio
export { RadioGroup, RadioGroupItem } from './primitives/radio';
export type { RadioGroupProps, RadioGroupItemProps } from './primitives/radio';

// ScrollArea
export { ScrollArea, ScrollBar } from './primitives/scroll-area';
export type { ScrollAreaProps, ScrollBarProps } from './primitives/scroll-area';

// Select
export {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectLabel,
  SelectItem,
  SelectSeparator,
} from './primitives/select';
export type {
  SelectProps,
  SelectTriggerProps,
  SelectValueProps,
  SelectContentProps,
  SelectGroupProps,
  SelectLabelProps,
  SelectItemProps,
  SelectSeparatorProps,
} from './primitives/select';

// Skeleton
export { Skeleton } from './primitives/skeleton';

// Spinner
export { Spinner } from './primitives/spinner';
export type { SpinnerProps } from './primitives/spinner';

// Switch
export { Switch, switchVariants } from './primitives/switch';
export type { SwitchProps } from './primitives/switch';

// Tabs
export { Tabs, TabsList, TabsTrigger, TabsContent } from './primitives/tabs';
export type {
  TabValue,
  TabsProps,
  TabsListProps,
  TabsTriggerProps,
  TabsContentProps,
} from './primitives/tabs';

// Toast
export { Toaster, toast } from './primitives/toast';
export type {
  ToasterProps,
  ToastPosition,
  ToastType,
} from './primitives/toast';

// Tooltip
export {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from './primitives/tooltip';
export type {
  TooltipProviderProps,
  TooltipProps,
  TooltipTriggerProps,
  TooltipContentProps,
} from './primitives/tooltip';

// Utilities
export { cn } from './utils/cn';
export { focusVisibleStyles, motionSafe } from './utils/focus';
export { useInheritedColorScheme } from './utils/use-inherited-color-scheme';

// Shared Types
export type {
  ComponentPropsWithVariants,
  RenderProp,
  ColorScheme,
  Aesthetic,
} from './types/index';
